<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="设备uuid：" prop="code">
                    <el-input v-model.trim="form.uuid" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="uid：" prop="uid">
                    <el-input v-model.trim="form.uid" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="创建时间：" prop="createTime">
                    <el-date-picker v-model="createTime" type="datetimerange" start-placeholder="开始时间"
                        end-placeholder="结束时间" format="YYYY-MM-DD HH:mm:ss" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass" @click="query">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="list" size="mini">
            <el-table-column label="日志id" width="220">
                <template v-slot="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="设备uuid" width="150">
                <template v-slot="scope">
                    <span>{{ scope.row.uuid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="uid" width="150">
                <template v-slot="scope">
                    <span>{{ scope.row.uid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="appid" width="150">
                <template v-slot="scope">
                    <span>{{ scope.row.schema }}</span>
                </template>
            </el-table-column>
            <el-table-column label="固件版本" width="150">
                <template v-slot="scope">
                    <span>{{ scope.row.software }}</span>
                </template>
            </el-table-column>
            <el-table-column label="日志">
                <template v-slot="scope">
                    <a :href="scope.row.log_url" download style="color: #409EFF;cursor: pointer;">下载</a>
                </template>
            </el-table-column>
            <el-table-column label="app版本">
                <template v-slot="scope">
                    <span>{{ scope.row.app_version }}</span>
                </template>
            </el-table-column>
            <el-table-column label="上报时间" width="180">
                <template v-slot="scope">
                    <span>{{ dayjs.unix(scope.row.report_time).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="180">
                <template v-slot="scope">
                    <span>{{ dayjs.unix(scope.row.create_time).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
            <el-button type="text" :disabled="predisabled" @click="prePage" size="mini">上一页</el-button>
            <el-button type="text" :disabled="nextdisabled" @click="nextPage" size="mini">下一页</el-button>
        </div>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw, watch } from 'vue'
import { ElMessage } from 'element-plus'
import util from '../../../util/util'
import api from '../../../axios/api'
import dayjs from 'dayjs'

export default {
    components: {
    },
    setup() {
        const form = reactive({
            uuid: '',
            uid: '',
            identifier: '',
            begin_time: '',
            end_time: ''
        })
        const pagination = reactive({
            action: 2, // 2向后翻页 1向前翻页
            last_id: '',
            rows: 10
        })
        const formRef = ref()
        const list = ref([])
        const createTime = ref('')
        const predisabled = ref(false)
        const nextdisabled = ref(false)

        const prePage = () => {
            pagination.action = 1
            pagination.last_id = list.value[0].id
            onSearch()
        }

        const nextPage = () => {
            pagination.action = 2
            pagination.last_id = list.value[list.value.length - 1].id
            onSearch()
        }

        const query = () => {
            pagination.last_id = ''
            onSearch()
        }

        const onSearch = async () => {
            console.log('toRaw(form)', toRaw(form))
            const res = await api.LiveLoadingLog({
                ...toRaw(form),
                action: pagination.action,
                last_id: pagination.last_id,
                rows: pagination.rows
            })
            console.log('onSearch', res)
            if (res.data.code === 200) {
                if (res.data.data.data) {
                    list.value = res.data.data.data
                    if (pagination.action === 1) {
                        nextdisabled.value = false
                    } else {
                        predisabled.value = false
                    }
                } else {
                    if (pagination.last_id === '') {
                        list.value = []
                    }
                    if (pagination.action === 1) {
                        predisabled.value = true
                    } else {
                        nextdisabled.value = true
                    }
                }
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        watch(createTime, (newVal) => {
            console.log('newVal', newVal)
            if (newVal) {
                form.begin_time = dayjs(newVal[0]).unix()
                form.end_time = dayjs(newVal[1]).unix()
            } else {
                form.begin_time = ''
                form.end_time = ''
            }
        })

        onMounted(() => {
            onSearch()
        })

        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            resetForm,
            util,
            createTime,
            predisabled,
            nextdisabled,
            prePage,
            nextPage,
            query,
            dayjs
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
    font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
    ::v-deep(tbody) {
        tr {
            font-family: 'Manrope';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            opacity: 0.8;
        }
    }
    .editor {
        height: 400px;
    }
    .page {
        float: right;
        margin-top: 10px
    }
}
</style>
